
const user = JSON.parse(localStorage.getItem('user'))
export const userData = user
